export const filterBuyerAvailableLocations = (userLocations = [], availableLocations = []) =>
  availableLocations.filter(({ _id }) => userLocations.includes(_id));
